<template>
  <div class="incomeFlow">
     <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- <div style="float:left;">
          <el-button type="text" style="font-size:17px;">金额：{{totalMoney}}</el-button>
        </div> -->
        <span style="line-height: 36px; text-align: center;">运维记录</span>
        <div style="float:right">
  
          <el-select v-model="alarmType" placeholder="账号级别" class="acclevel">
            <el-option
              v-for="item in alarmTypes"
              :key="item.name"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="alarmStatus" placeholder="状态">
            <el-option
              v-for="item in alarmStatuses"
              :key="item.value"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
          <el-date-picker
            v-model="startTime"
            value-format="yyyy-mm-dd"
            type="date"
            placeholder="开始日期">
          </el-date-picker>
          <el-date-picker
            v-model="endTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期">
          </el-date-picker>
          <el-button type="success" @click="btnSearch">查询</el-button>
        </div>
      </div>
      <div>
        <el-table
        v-loading="table_loading"
        element-loading-text="拼命加载中"
        :data="deviceData"
        stripe
        border
        fit
        height="520"
        style="width: 100%">
        <el-table-column
          prop="id"
          header-align="center"
          min-width="40"
          label="编号">
        </el-table-column>

        <el-table-column
          prop="user"
          header-align="center"
          min-width="80"
          label="操作人">
          <template scope="scope">
            <span>{{scope.row.nickName+"("+scope.row.userName+")"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          header-align="center"
          min-width="80"
          label="操作类型">
          <template scope="scope">
            <span>{{scope.row.type==0?"补货":scope.row.type==1?"维修":"离线处理"}}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop=""
          header-align="center"
          min-width="80"
          label="处理结果">
          <template scope="scope">
            <span>{{scope.row.status==0?"未处理":"已处理"}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          header-align="center"
          min-width="80"
          label="处理内容">
          <template scope="scope">
            <span>{{scope.row.title}}</span><br>
            <span>{{scope.row.memo}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          header-align="center"
          min-width="80"
          label="现场照片">
          <template scope="scope">
           <img :src="scope.row.imgUrl" style="width:80px;"></img>
          </template>
        </el-table-column>
        <el-table-column
          prop="deviceCode"
          header-align="center"
          min-width="80"
          label="设备编号">
        </el-table-column>
        <el-table-column
          prop="addToNum"
          header-align="center"
          min-width="50"
          label="货物数量">
        </el-table-column>
        <el-table-column
          prop="createTime"
          header-align="center"
          min-width="80"
          label="处理时间">
        </el-table-column>
      </el-table>
      </div>
      <div class="table_pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
    </el-card>
    </div>
  </template>
  <script>
      import $axios from '../../https/config'
  
      export default {
        data () {
          return {
            deviceData: [],
            pageTotal: 0,
            pageSize: 10,
            pageNo: 1,
            table_loading: false,
            endTime: '',
            startTime: '',
            alarmTypes: [],
            alarmType: '',
            //type=0,补货,type=1,维修,type=2 处理离线
            alarmStatuses: [{
              key: '',
              value: '全部类型'
            }, {
              key: '0',
              value: '补货'
            }, {
              key: '1',
              value: '维修'
            }, {
              key: '2',
              value: '处理离线'
            }],

            Statuss: [{
              key: '',
              value: '全部状态'
            }, {
              key: '0',
              value: '待处理'
            }, {
              key: '1',
              value: '已处理'
            }],
            status:'',
            alarmStatus: '',
            deviceCode: '',
            date: '',
            totalMoney: ''
          }
        },
        created: function () {
          this.pageNo = 1
          this.getAccountList()
          this.queryDeviceList(this.pageNo, this.pageSize,this.alarmType,this.status,  this.alarmStatus, this.startTime, this.endTime)
        },
        methods: {
          btnSearch () {
            this.queryDeviceList(this.pageNo, this.pageSize,this.alarmType,this.status,  this.alarmStatus, this.startTime, this.endTime)
          },
          getAccountList () {
            var _this = this
            $axios.get('/system/queryAcccount', null, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                for (let i = 0; i < res.resultData.list.length; i++) {
                  var usertype = res.resultData.list[i].user_type === 1 ? '代理商' : '设备主'
                  _this.alarmTypes.push({
                    id: res.resultData.list[i].id,
                    name: usertype + '-' + (res.resultData.list[i].nickName!=null?res.resultData.list[i].nickName:res.resultData.list[i].user_name)+"-"+(res.resultData.list[i].id)
                  })
                }
                _this.alarmTypes.unshift({
                  id: '',
                  name: '全部账号'
                })
              }
            })
          },
          queryDeviceList (tPageNo, tPageSize, tFaultId, tStatus, tType, startTime, endTime) {
            var _this = this
            var params = {
              pageNo: tPageNo,
              pageSize: tPageSize,
              userId: tFaultId + '',
              status: tStatus,
              type: tType,
              startTime: startTime === '' ? '' : new Date(startTime).getFullYear() + '-' + (new Date(startTime).getMonth() + 1) + '-' + new Date(startTime).getDate(),
              endTime: endTime === '' ? '' : new Date(endTime).getFullYear() + '-' + (new Date(endTime).getMonth() + 1) + '-' + new Date(endTime).getDate()
            }
            this.table_loading = true
            this.deviceData = []
            $axios.post('/adminApp/listMaintainAdmin', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                if (res.resultData && res.resultData.list.length > 0) {
                  _this.pageTotal = res.resultData.count
                  _this.deviceData = res.resultData.list
                  // _this.totalMoney = (res.resultData.totalMoney / 100).toFixed(2) + '元'
                }
              } else {
              }
              _this.table_loading = false
            }, function () {
            })
          },
          handleSizeChange (val) {
            this.pageSize = val
            this.queryDeviceList(this.pageNo, this.pageSize, this.alarmType, this.status, this.alarmStatus, this.startTime, this.endTime)
          },
          handleCurrentChange (val) {
            this.pageNo = val
            this.queryDeviceList(this.pageNo, this.pageSize, this.alarmType,this.status, this.alarmStatus, this.startTime, this.endTime)
          }
        }
      }
  </script>
  <style lang="scss">
      .table_pagination {
        text-align: right;
        margin-top: 10px; 
      }
      .incomeFlow {
          .el-select .el-input {
            width: 110px;
          }
          .acclevel .el-input{
            width: 200px;
          }
      }
  </style>


// WEBPACK FOOTER //
// src/page/opMgr/opRecord.vue